import React, { useEffect } from "react";
import { Card } from "primereact/card";
import useUsers from "./useUsers";
import { TabPanel, TabView } from "primereact/tabview";
import UserListTable from "./UserListTable";
import UserDeleteDialog from "./UserDeleteDialog";
import AlertMessage from "./AlertMessage";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";
import { useNavigate } from "react-router-dom";

const UserManagement = () => {
  const {
    users,
    loading,
    setSearchQuery,
    searchQuery,
    role,
    setRole,
    isDataAvailable,
    page,
    rows,
    totalRecords,
    onPageChange,
    openDialog,
    setOpenDialog,
    handleDelete,
    handleOpenDialog,
    selectedUser,
    deleteUserStatus,
    setDeleteUserStatus,
    setSelectedUser,
  } = useUsers();

  const navigate = useNavigate();

  const { value: isTenantFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.TENANT,
    false,
  );

  useEffect(() => {
    isTenantFeatureEnabled && navigate("/forbidden");
  }, [isTenantFeatureEnabled]);

  return (
    <Card className="gen-card mt-0 h-full">
      <div className="general-info-container flex flex-column formgrid grid grid-nogutter">
        <p className="profile-heading">Users</p>
        <p className="profile-para">Manage your users settings.</p>
      </div>
      <div className={`tabview-wrapper ${loading ? "disabled" : ""}`}>
        {loading && <div className="tabview-overlay" />}
        <TabView
          activeIndex={role}
          onTabChange={(e) => {
            if (!loading) {
              setRole(e.index);
            }
          }}
        >
          <TabPanel header="GXM" />
          <TabPanel header="Local Team" />
          <TabPanel header="Customer" />
        </TabView>
      </div>
      <div className="flex-1 mb-5">
        <div className="input-wrapper-container width__full">
          <span className="pi pi-search"></span>
          <input
            type="text"
            placeholder="Search by Name or Email"
            className=" appearance-none outline-none w-full"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      {deleteUserStatus.toasterVisible && (
        <AlertMessage
          className="mb-3"
          summary={`${selectedUser?.first_name} ${selectedUser?.last_name} has been removed`}
          detail="This user no longer in the system"
          handleClose={() => {
            setDeleteUserStatus({
              toasterVisible: false,
              deleted: false,
              loading: false,
            });
            setSelectedUser(null);
          }}
          type="error"
        />
      )}
      <UserListTable
        users={users}
        loading={loading}
        page={page}
        rows={rows}
        totalRecords={totalRecords}
        onPageChange={onPageChange}
        handleOpenDialog={handleOpenDialog}
        isDataAvailable={isDataAvailable}
      />

      <UserDeleteDialog
        setOpenDialog={setOpenDialog}
        open={openDialog}
        handleDelete={handleDelete}
        selectedUser={selectedUser}
        loading={deleteUserStatus?.loading}
      />
    </Card>
  );
};

export default UserManagement;
